import type { ReactNode } from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "../auth";
import { NavShell } from "./NavShell";

/**
 * Wraps every authenticated screen: redirects to /login if there's no user,
 * and redirects a TENANT-LESS superadmin away from tenant screens straight
 * to Settings (every tenant-scoped endpoint 403s without a tenant). A
 * superadmin who also owns a tenant (dual-capability) uses tenant screens
 * normally.
 */
export function ProtectedRoute({
  children,
  tenantOnly,
}: {
  children: ReactNode;
  tenantOnly?: boolean;
}) {
  const { user } = useAuth();
  if (!user) return <Navigate to="/login" replace />;
  if (tenantOnly && user.role === "superadmin" && !user.tenantId) return <Navigate to="/settings" replace />;
  return <NavShell>{children}</NavShell>;
}
